import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
type Purchase = {
  name: string;
  city: string;
};
type Notification = Purchase & {
  offer: string;
  key: string;
};
const purchases: Purchase[] = [{
  name: 'Camila S.',
  city: 'Buenos Aires'
}, {
  name: 'Rocío D.',
  city: 'Rosario'
}, {
  name: 'Antonella P.',
  city: 'Córdoba'
}, {
  name: 'Valentina G.',
  city: 'Mendoza'
}, {
  name: 'Sofía R.',
  city: 'La Plata'
}, {
  name: 'Micaela T.',
  city: 'Mar del Plata'
}, {
  name: 'Julieta M.',
  city: 'Salta'
}, {
  name: 'Florencia N.',
  city: 'Tucumán'
}, {
  name: 'Agustina L.',
  city: 'Neuquén'
}, {
  name: 'Brenda K.',
  city: 'San Juan'
}];
const offers = ['Kit de Colorimetría PRO', 'Megapack de Colorimetría PRO'];
function randomBetween(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function createNotification(previousKey: string | null): Notification {
  let notification: Notification;
  do {
    const purchase = purchases[randomBetween(0, purchases.length - 1)];
    const offer = offers[randomBetween(0, offers.length - 1)];
    notification = {
      ...purchase,
      offer,
      key: `${purchase.name}-${offer}`
    };
  } while (notification.key === previousKey);
  return notification;
}
export function SocialProofNotification() {
  const [notification, setNotification] = useState<Notification | null>(null);
  const lastNotificationKey = useRef<string | null>(null);
  const displayTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const nextTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const clearTimers = useCallback(() => {
    if (displayTimer.current) window.clearTimeout(displayTimer.current);
    if (nextTimer.current) window.clearTimeout(nextTimer.current);
  }, []);
  const scheduleNext = useCallback(() => {
    if (nextTimer.current) window.clearTimeout(nextTimer.current);
    nextTimer.current = window.setTimeout(() => {
      const nextNotification = createNotification(lastNotificationKey.current);
      lastNotificationKey.current = nextNotification.key;
      setNotification(nextNotification);
      displayTimer.current = window.setTimeout(() => {
        setNotification(null);
        scheduleNext();
      }, randomBetween(5000, 7000));
    }, randomBetween(40000, 60000));
  }, []);
  useEffect(() => {
    scheduleNext();
    return clearTimers;
  }, [clearTimers, scheduleNext]);
  const dismiss = () => {
    if (displayTimer.current) window.clearTimeout(displayTimer.current);
    setNotification(null);
    scheduleNext();
  };
  return <AnimatePresence data-id="element-278" data-mp="1ovoluht13fws">
      {notification && <motion.aside key={notification.key} initial={{
      opacity: 0,
      x: -24
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -24
    }} transition={{
      duration: 0.28,
      ease: 'easeOut'
    }} aria-live="polite" aria-label="Compra verificada" className="fixed bottom-20 left-3 z-40 w-[calc(100%-1.5rem)] max-w-[330px] rounded-2xl border border-rosegold/15 bg-white/95 p-3.5 pr-9 shadow-xl shadow-plum/15 backdrop-blur sm:bottom-5 sm:left-5 sm:w-[330px] sm:p-4" data-id="element-279" data-mp="1ktbiu15o1w3p">
          <button type="button" onClick={dismiss} aria-label="Cerrar notificación" className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-full text-plum/45 transition-colors hover:bg-blush hover:text-plum" data-id="element-280" data-mp="1aqo82in5ir5s">
            <XIcon className="h-3.5 w-3.5" data-id="element-281" data-mp="i326th1ebym3" />
          </button>
          <div className="flex items-start gap-3" data-id="element-282" data-mp="n0llgi20adek">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700" data-id="element-283" data-mp="r1dy7la370fl">
              <CheckIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-284" data-mp="w0qqwmnn31q3" />
            </span>
            <div className="min-w-0" data-id="element-285" data-mp="22h2ig4vyhlcp">
              <p className="text-xs font-semibold leading-snug text-ink sm:text-sm" data-id="element-286" data-mp="22g16ly748utx">
                {notification.name} de {notification.city} compró el {notification.offer}
              </p>
              <p className="mt-1 text-[10px] font-medium text-plum/55 sm:text-xs" data-id="element-287" data-mp="25z9s7g6mv5z9">Compra verificada</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}